define([], function() {
    "use strict";

    const A_code = "A".charCodeAt(0);
    const Z_code = "Z".charCodeAt(0);
    const a_code = "a".charCodeAt(0);
    const z_code = "z".charCodeAt(0);
    const space_code = " ".charCodeAt(0);
    const dash_code = "-".charCodeAt(0);
    const underscore_code = "_".charCodeAt(0);

    return function(m2la) {
        return m2la.extend({
            initialize: function(config) {
                this._super(config);

                this.cleanCSSclass = function(name, prefix) {
                    prefix || (prefix = "lfi");
                    if (name.length) {
                        let firstCharCode = name.charCodeAt(0);
                        // Prefix the name if it's not a valid CSS class
                        if (
                            !(
                                firstCharCode >= A_code &&
                                firstCharCode <= Z_code
                            ) &&
                            !(
                                firstCharCode >= a_code &&
                                firstCharCode <= z_code
                            )
                        ) {
                            name = prefix + name;
                        }
                    }

                    // Replace non-lowercase and non-digit characters in the classname with "safe" characters
                    return name.replace(/[^a-z0-9]/g, function(s) {
                        var c = s.charCodeAt(0);
                        if (c === space_code || c === dash_code) {
                            return "-";
                        }
                        if (c === underscore_code) {
                            return "_g";
                        }
                        if (c >= A_code && c <= Z_code) {
                            return s.toLowerCase();
                        }
                        return "__" + ("000" + c.toString(16)).slice(-4);
                    });
                };
            }
        });
    };
});
